/**
 * Estado da homologação de um item (produto ou serviço) no Conta Azul.
 *
 * O Bewave cadastra e vende; o BPO parametriza no Conta Azul e devolve o ID.
 * Enquanto o vínculo não existe, o item opera normalmente e as vendas ficam
 * numa fila interna — nada bloqueia a escola.
 */
export type FiscalStatus = 'pending' | 'homologated' | 'integration_error'

export interface FiscalShareRequest {
  subject: string
  body: string
  url: string
}

export const FISCAL_STATUS_LABEL: Record<FiscalStatus, string> = {
  pending: 'Pendente',
  homologated: 'Homologado',
  integration_error: 'Erro de integração',
}
